/**
 * Dónde está el API. UN SOLO SITIO.
 *
 * Aquí se lee `VITE_API_URL` y aquí vive el prefijo; el cliente JSON, el
 * transporte del chat, las subidas y el WebSocket del dictado lo piden de
 * aquí. Antes cada uno leía la variable por su cuenta, y cambiar de host --o
 * de prefijo, como al pasar por el gateway-- era perseguirla por cinco
 * archivos.
 */

/**
 * El host del API, sin barra final. Vacío es "el mismo origen": en desarrollo,
 * el proxy de Vite. Se hornea al compilar (§12), no se lee en ejecución.
 */
export const API_URL: string = (import.meta.env.VITE_API_URL ?? "").replace(
  /\/+$/,
  "",
);

export const API_VERSION = "v1";

/**
 * El prefijo de las rutas. Lleva el nombre del servicio porque el gateway de
 * lala-ms no reescribe el path y cuelga cada servicio de `/api/<servicio>`
 * (§10.2). El backend declara el suyo en `transport/rest/controller.ts`: los
 * dos tienen que cambiar a la vez.
 */
export const API_BASE = `/api/embajadores/${API_VERSION}` as const;

/** La URL completa de una ruta del API: `apiUrl(`${API_BASE}/me`)`. */
export const apiUrl = (path: string): string => `${API_URL}${path}`;

/**
 * La misma ruta, por WebSocket. Sin host configurado se usa el de la página,
 * que es a donde apunta el proxy de Vite.
 */
export const wsUrl = (path: string): string => {
  const http = API_URL === "" ? globalThis.location.origin : API_URL;
  return `${http.replace(/^http/, "ws")}${path}`;
};
